import _ from 'underscore';
import store from '../../store';
import typeUtil from '../../common/js/typeUtil';

const storagePrefix = 'pc_';
export default {
    getLocalName(name) {
        if (name) {
            name = storagePrefix + name;
        }
        return name;
    },
    // 将数据存储在本地缓存中指定的 name 中
    set(name, data) {
        name = this.getLocalName(name);
        if (typeUtil.isObject(data) || typeUtil.isArray(data)) {
            data = JSON.stringify(data);
        }
        localStorage.setItem(name, data);
    },
    // 从本地缓存中获取指定 name 对应的内容
    get(name) {
        name = this.getLocalName(name);
        let data = localStorage.getItem(name);
        if (typeUtil.isString(data)) {
            try {
                data = JSON.parse(data);
            } catch (e) {

            }
        }
        return data;
    },
    // 从本地缓存中移除指定 key
    delete(name) {
        name = this.getLocalName(name);
        localStorage.removeItem(name);
    },
    // 返回一个布尔值，表示 name 是否在本地缓存之中
    has(name) {
        name = this.getLocalName(name);
        return localStorage.key(name)
    },
    // 清理本地数据缓存
    clear() {
        localStorage.clear();
    },
    //临时存储
    setItem(name, data) {
        name = this.getLocalName(name);
        if (typeUtil.isObject(data) || typeUtil.isArray(data)) {
            data = JSON.stringify(data);
        }
        sessionStorage.setItem(name, data);
    },
    getItem(name) {
        name = this.getLocalName(name);
        let data;
        data = sessionStorage.getItem(name);
        if (typeUtil.isString(data)) {
            try {
                data = JSON.parse(data);
            } catch (e) {

            }
        }
        return data;
    },
    getFriend() {
        let key = 0;
    },
    refreshApplyFriend() {
        let key = 'user_' + this.get('userId') + '_apply_friend';

        let values = this.get(key);
        if (!values) {
            store.state.applyFriendNumber = values.length;
        } else {
            store.state.applyFriendNumber = 0;
        }
    },
    addApplyFriend(msg) {
        let key = 'user_' + this.get('userId') + '_apply_friend';

        let values = this.get(key);
        if (!values) {
            values = [];
        }
        let applyFriend = _.find(values, item => {
            return item.fromId === msg.fromId;
        });
        if (!applyFriend) {
            values.push(msg);
        }
        this.set(key, values);
        store.state.applyFriendNumber = values.length;
        return values.length;
    },
    clearApplyFriend() {
        let key = 'user_' + this.get('userId') + '_apply_friend';
        this.delete(key);
        store.state.applyFriendNumber = 0;
    },
    clearMsg(friendId, type) {
        let key;
        if (type === 'p2p') {
            key = 'user_' + this.get('userId') + '_friend_' + friendId;
        } else if (type === 'team') {
            key = 'user_' + this.get('userId') + '_team_' + friendId;
        }
        this.delete(key);
    },
    getMsg(friendId, type) {
        let key;
        if (type === 'p2p') {
            key = 'user_' + this.get('userId') + '_friend_' + friendId;
        } else if (type === 'team') {
            key = 'user_' + this.get('userId') + '_team_' + friendId;
        }
        let data = this.get(key);
        if (!data) {
            return [];
        }
        return data;
    },
    replaceMsg(friendId, msgs) {
        let key;
        if (msgs[0].scene === 'p2p') {
            key = 'user_' + this.get('userId') + '_friend_' + friendId;
        } else if (msgs[0].scene === 'team') {
            key = 'user_' + this.get('userId') + '_team_' + friendId;
        }
        this.set(key, msgs);
    },
    saveMsg(msg) {
        let friendId = msg.fromId;
        let key;
        if (msg.scene === 'p2p') {
            if (friendId == this.get('userId')) {
                key = 'user_' + this.get('userId') + '_friend_' + msg.toId;
            }
        } else if (msg.scene === 'team') {
            key = 'user_' + this.get('userId') + '_team_' + msg.teamId;
        }
        let localMsg = this.get(key);

        if (!localMsg) {
            localMsg = [];
        }
        let add = _.find(localMsg, i => {
            return i.id == msg.id;
        });

        if (!add) {
            localMsg.push(msg);
            this.set(key, localMsg);
        } else {

            add.state = msg.state;
            add.errorMsg = msg.errorMsg;
            add.read = msg.read;
            if (msg.msgType === 'removeTeamMembers' || msg.msgType === 'addTeamMembers' || msg.msgType === 'creatTeam') {

                localMsg.push(msg);
            }

            this.set(key, localMsg);


        }
    },
    clearChatNumber(friendId) {
        let key = "user_" + this.get('userId') + '_chatFriend';
        let chats = this.get(key);
        if (!chats) {
            chats = [];
        }

        let needAdd = _.find(chats, item => {
            return item.friendId === friendId;
        });

        if (needAdd) {
            needAdd.chatNum = 0;
            this.set(key, chats);
        }
    },
    getChat() {
        let key = "user_" + this.get('userId') + '_chatFriend';
        return this.get(key);
    },
    replaceChat(chats) {
        let key = "user_" + this.get('userId') + '_chatFriend';
        this.set(key, chats);
    },
    saveChat(friend) {
        let key = "user_" + this.get('userId') + '_chatFriend';
        let chats = this.get(key);
        if (!chats) {
            chats = [];
        }

        let needAdd = _.some(chats, item => {
            return item.id === friend.id && item.scene === friend.scene;
        });
        if (!needAdd) {
            chats.push({
                id: friend.id,
                userId: friend.userId,
                friendId: friend.friendId,
                friendNick: friend.friendNick,
                scene: friend.scene,
                avatar: friend.avatar,
                chatNum: friend.chatNum,
                lastMsg: friend.lastMsg
            });
            this.set(key, chats);
        } else {
            let friendX = _.find(chats, item => {
                return item.id === friend.id && item.scene === friend.scene;
            });
            friendX.chatNum = friend.chatNum;
            friendX.lastMsg = friend.lastMsg;

            this.set(key, chats);
        }
    },
    playNotice() {
        let audio = new Audio();
        audio.src = require("../../static/audio/audio.mp3");
        audio.play();
        // innerAudioContext.onPlay(() => {
        //   console.log('开始播放');
        // });
    }
}
